module.exports = __webpack_public_path__ + "assets/img/2007.e09997d7.png";